module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.registros && _vm.registros.length) ? _c('ul', {
    staticClass: "list-group listagem-registros",
    on: {
      "mouseleave": function($event) {
        _vm.onResultadosMouseLeave()
      }
    }
  }, _vm._l((_vm.registros), function(r) {
    return _c('li', {
      staticClass: "list-group-item",
      on: {
        "mouseenter": function($event) {
          _vm.onRegistroMouseEnter(r)
        }
      }
    }, [_c('span', {
      staticClass: "listagem-registros-titulo",
      attrs: {
        "title": r.titulo
      }
    }, [_vm._v(_vm._s(r.titulo || r.nomeCamada))]), _c('small', {
      staticClass: "listagem-registros-subtitulo"
    }, [_vm._v(_vm._s(r.nomeCamada))]), _c('i', {
      staticClass: "action-icon fa fa-chevron-right pull-right",
      on: {
        "click": function($event) {
          _vm.exibirRegistro(r)
        }
      }
    })])
  })) : _vm._e(), (_vm.registros && _vm.registros.length === 0) ? _c('empty-result', {
    staticClass: "full-height",
    attrs: {
      "message": "Nenhum resultado encontrado."
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eec39d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListagemRegistrosCamada.vue
// module id = 488
// module chunks = 1